import React, { useContext } from 'react';
import { DateTime } from 'luxon';
import { OptionList } from '../../OptionList';
import { checkScope } from '../utils';
import { Tooltip } from '../../Tooltip';
import { BodyText } from '../../BodyText';
import { TimezoneContext, toDateFormat } from '../../../utilities';
export const DateRangeOptionList = ({ options, min, max, onChange, enableTimezoneContext, }) => {
    const timezone = useContext(TimezoneContext);
    const normalizeValueInOptions = options.map((option) => {
        let start;
        let end;
        if (enableTimezoneContext) {
            start = option.value.start
                ? DateTime.fromJSDate(option.value.start)
                    .setZone(timezone)
                    .startOf('day')
                    .toJSDate()
                : null;
            end = option.value.end
                ? DateTime.fromJSDate(option.value.end)
                    .setZone(timezone)
                    .endOf('day')
                    .toJSDate()
                : null;
        }
        else {
            start = toDateFormat.startOfDay(option.value.start);
            end = toDateFormat.endOfDay(option.value.end);
        }
        return Object.assign(Object.assign({}, option), { value: {
                start,
                end,
            } });
    });
    const checkOptions = normalizeValueInOptions.map((option) => {
        const isOutOfScope = checkScope(option.value, min, max);
        if (isOutOfScope.start || isOutOfScope.end) {
            return Object.assign(Object.assign({}, option), { disabled: true, content: (React.createElement(Tooltip, { direction: "r", portal: true, text: "Out of Date Range" },
                    React.createElement(BodyText, { size: "small" }, option.text))) });
        }
        return option;
    });
    const handleOnChange = (data) => {
        onChange(data);
    };
    return (React.createElement(React.Fragment, null, checkOptions.length > 0 && (React.createElement("div", { className: "DateRangePicker__options" },
        React.createElement(OptionList, { options: checkOptions, onChange: (data) => handleOnChange(data) })))));
};
//# sourceMappingURL=DateRangeOptionList.js.map